module.exports = __webpack_public_path__ + "img/cp-ai-4.d72268cb.jpg";